import type { ModalRouteGateProps } from "./router-modal-routes.type";

import { Navigate, useLocation } from "react-router";

import { usePageModalLocationState } from "@/modules/page-modal";

import { useModalRouteGateParentPath } from "./router-modal-routes.hook";

export const ModalRouteGate = ({
  parentRoute,
  children,
}: ModalRouteGateProps) => {
  const location = useLocation();
  const parentPath = useModalRouteGateParentPath(parentRoute);
  const { backgroundLocation } = usePageModalLocationState();

  // If page is supposed to be a modal but `pageModal` props do not exist in
  // location object, redirect user to the same page with `pageModal` props:
  // -> `backgroundLocation`: is the page displayed on modal background
  //     and the redirect url on modal close (home page by default)
  // doc: https://v5.reactrouter.com/web/example/modal-gallery
  if (!backgroundLocation) {
    return (
      <Navigate
        to={location.pathname}
        state={{ pageModal: { backgroundLocation: { pathname: parentPath } } }}
        replace
      />
    );
  }

  // Otherwise, render the route content
  return children;
};
